import {
    Component,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
} from '@angular/core';
import {SubscriptionViewModel} from '../../../../shared/viewModels/subscription.viewModel';
import {UserProfileViewModel} from '../../../../shared/viewModels/userProfile.viewModel';
import {Constants} from '../../../../shared/config/constants.config';
import {MasterNote, MasterService} from '../../../../shared/services/master.service';
import {UsersService} from '../../../../shared/services/users.service';
import {AuthService} from '../../../../shared/services/auth.service';
import {AppLoadingEventsEmitter} from '../../../../shared/events/loading.events';
import {NotificationsService} from '../../../../shared/services/notification.service';
import {ActivatedRoute, Router} from '@angular/router';
import * as moment from 'moment';


@Component({
    selector: 'app-notes-edit',
    templateUrl: './notes-edit.component.html',
    styleUrls: ['./notes-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotesEditComponent {
    activeTab = 'personal';
    id: number;
    noteId: number;
    profile: UserProfileViewModel;
    title = '';
    html = '';
    note: MasterNote;

    constructor(
        public readonly constants: Constants,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly masterService: MasterService,
        private readonly usersService: UsersService,
        private readonly authService: AuthService,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly notificationService: NotificationsService,
        private readonly route: ActivatedRoute,
        readonly router: Router,
    ) {
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnInit() {
        this.route.params.subscribe(params => {
            // tslint:disable-next-line:radix
            this.id = parseInt(params['id']);
            // tslint:disable-next-line:radix
            this.noteId = parseInt(params['noteId']);

            const activeTab = this.route.snapshot.paramMap.get('section');

            if (activeTab) {
                this.activeTab = activeTab;
                this.changeDetectorRef.detectChanges();
            }

            this.masterService.getUserProfile(this.id).subscribe(profile => {
                this.profile = profile;
                this.changeDetectorRef.markForCheck();
            });

            this.init();
        });
    }

    init() {
        this.masterService.getSingleNote(this.id, this.noteId).subscribe(note => {
            this.note = note;
            this.title = note.title;
            this.html = note.text;

            this.changeDetectorRef.markForCheck();
        });
    }

    openUserMeals(profile: UserProfileViewModel) {
        this.masterService.masterLogin(profile.id).subscribe(token => {
            this.authService.setStorageItem('original_logged_token', this.authService.getJWT());
            this.authService.setStorageItem('master_sub_profile_logged_token', token.token);

            this.router.navigate(['/master/meals', profile.id]);
        });
    }

    openMessages(profile: UserProfileViewModel) {
        this.router.navigate(['/master/messages', profile.id]);
    }

    onTitleChange(title) {
        this.title = title.target.value;
        this.changeDetectorRef.markForCheck();

    }

    save() {
        this.masterService.updateNote(this.profile.id, this.noteId, this.title, this.html).subscribe(() => {
            this.router.navigate(['master/profiles/notes', this.profile.id]);
        });
    }

    change($event: any) {
        if ($event.length > 0) {
            this.html = $event;
            this.changeDetectorRef.markForCheck();
        }
    }

}
